import {
    AfterContentInit, Component, ComponentFactoryResolver, HostListener, Input, OnDestroy,
    ViewChild, ViewContainerRef
} from '@angular/core';
import {CarouselItemComponent} from './carousel-item.component';
import {SlideZoneDirective} from './slide-zone.directive';
import {CarouselSlideComponent} from './carousel-slide.component';

const /** @type {?} */ STATE_AVAILABLE = 'available';
const /** @type {?} */ STATE_IDLE = 'idle';
export class CarouselComponent implements AfterContentInit, OnDestroy {
private autoPlay = true;
private time = 4;
private slidesZone;
private sliderContainer;
private slideZone: SlideZoneDirective;
public slides: Array<CarouselItemComponent> = [];
private viewContainerRef: ViewContainerRef;
private carouselSlides: Array<CarouselSlideComponent> = [];
private x = 0;
private startX = 0;
private state = STATE_AVAILABLE;
private lastOffset = 0;
private index = 0;
private interval;
private pause;
private initialWindowWidth;
/**
 * @param {?} componentFactoryResolver
 */
constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    }
/**
 * @return {?}
 */
ngAfterContentInit() {
        this.initialWindowWidth = window.innerWidth;
        this.viewContainerRef = this.slideZone.viewContainerRef;
        this.lastOffset -= this.sliderContainer.nativeElement.getBoundingClientRect().width;
        let /** @type {?} */ component = this.createComponent(this.slides[this.slides.length - 1]);
        this.carouselSlides.push(component);
        this.slides.forEach((slide, index) => {
            if (index != this.slides.length - 1) {
                let /** @type {?} */ component = this.createComponent(slide);
                this.carouselSlides.push(component);
            }
        });

        if (this.autoPlay) {
            this.interval = setInterval(() => {
                if (!this.pause) {
                    this.slideForward();
                }
            }, this.time * 1000);
        }
    }
/**
 * @param {?} slide
 * @return {?}
 */
createComponent(slide) {
        let /** @type {?} */ componentFactory = this.componentFactoryResolver.resolveComponentFactory(CarouselSlideComponent);
        let /** @type {?} */ componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.src = slide.src;
        componentRef.instance.route = slide.route;
        componentRef.instance.link = slide.link;
        componentRef.instance.stabilizes(this.lastOffset);
        return componentRef.instance;
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
/**
 * @param {?} slide
 * @return {?}
 */
addSlideData(slide: CarouselItemComponent) {
        this.slides.push(slide);
    }
/**
 * @param {?} slide
 * @return {?}
 */
removeSlide(slide: CarouselItemComponent) {

    }
/**
 * @param {?} event
 * @return {?}
 */
onResize(event) {
        this.lastOffset = 0 - this.sliderContainer.nativeElement.getBoundingClientRect().width;
        this.carouselSlides.forEach((slide) => {
            slide.stabilizes(this.lastOffset);
        });
    }
/**
 * @return {?}
 */
pauseAutoPlay() {
        this.pause = true;
    }
/**
 * @return {?}
 */
startAutoPlay() {
        this.pause = false;
    }
/**
 * @param {?} event
 * @return {?}
 */
onPanStart(event: any): void {
        event.preventDefault();
        this.startX = this.x;
    }
/**
 * @param {?} event
 * @return {?}
 */
onPan(event: any): void {
        event.preventDefault();
        this.x = this.startX + event.deltaX;
        if (this.state === STATE_AVAILABLE) {
            this.carouselSlides.forEach((slide) => {
                slide.stabilizes(this.lastOffset + this.x);
            });
        }
    }
/**
 * @return {?}
 */
onPanEnd() {
        let /** @type {?} */ swipePercent = Math.abs(this.x) * 100 / this.sliderContainer.nativeElement.getBoundingClientRect().width;
        swipePercent = Math.abs(100 - swipePercent);
        if (this.x < 0) {
            this.slideForward(swipePercent);
        } else {
            this.slideBack(swipePercent);
        }
        this.x = 0;
    }
/**
 * @param {?=} deleyPercent
 * @return {?}
 */
slideBack(deleyPercent = null) {
        if (this.state === STATE_AVAILABLE) {
            this.state = STATE_IDLE;

            this.lastOffset += this.sliderContainer.nativeElement.getBoundingClientRect().width;
            this.carouselSlides.forEach((slide) => {
                slide.slide(this.lastOffset, deleyPercent);
            });

            setTimeout(() => {
                let /** @type {?} */ ref = this.viewContainerRef.get(this.carouselSlides.length - 1);
                this.viewContainerRef.move(ref, 0);
                this.lastOffset -= this.sliderContainer.nativeElement.getBoundingClientRect().width;
                this.carouselSlides.forEach((slide) => {
                    slide.stabilizes(this.lastOffset);
                });
                this.state = STATE_AVAILABLE;
                this.index--;
                if (this.index < 0) {
                    this.index = this.slides.length - 1;
                }
            }, 720);
            setTimeout(() => {
                this.pause = false;
            }, this.time * 1000);

        }
    }
/**
 * @param {?=} deleyPercent
 * @return {?}
 */
slideForward(deleyPercent = null) {
        if (this.state === STATE_AVAILABLE) {

            this.state = STATE_IDLE;

            this.lastOffset -= this.sliderContainer.nativeElement.getBoundingClientRect().width;
            this.carouselSlides.forEach((slide) => {
                slide.slide(this.lastOffset, deleyPercent);
            });

            setTimeout(() => {
                let /** @type {?} */ ref = this.viewContainerRef.get(0);
                this.viewContainerRef.move(ref, this.carouselSlides.length - 1);
                this.lastOffset = 0 - this.sliderContainer.nativeElement.getBoundingClientRect().width;
                this.carouselSlides.forEach((slide) => {
                    slide.stabilizes(this.lastOffset);
                });
                this.state = STATE_AVAILABLE;
                this.index++;
                if (this.index > this.slides.length - 1) {
                    this.index = 0;
                }
            }, 720);
        }

    }
/**
 * @param {?} index
 * @return {?}
 */
slideToIndex(index) {
        if (index > this.index) {
            console.log("Index:");
            console.log(index);
            console.log("This index:");
            console.log(this.index);

            if (this.state === STATE_AVAILABLE) {
                this.state = STATE_IDLE;
                this.lastOffset -= this.sliderContainer.nativeElement.getBoundingClientRect().width;
                this.carouselSlides.forEach((slide) => {
                    slide.slide(this.lastOffset);
                });
                setTimeout(() => {
                    let /** @type {?} */ ref = this.viewContainerRef.get(this.index);

                    this.viewContainerRef.move(ref, this.carouselSlides.length - 1);
                    this.lastOffset = 0 - this.sliderContainer.nativeElement.getBoundingClientRect().width;
                    this.carouselSlides.forEach((slide) => {
                        slide.stabilizes(this.lastOffset);
                    });
                    this.state = STATE_AVAILABLE;
                    this.index++;
                    if (this.index > this.slides.length - 1) {
                        this.index = 0;
                    }
                }, 720);
            }
        } else if (index < this.index) {
            console.log("Index:");
            console.log(index);
            console.log("This index:");
            console.log(this.index);

            if (this.state === STATE_AVAILABLE) {
                this.state = STATE_IDLE;
                this.lastOffset += this.sliderContainer.nativeElement.getBoundingClientRect().width;
                this.carouselSlides.forEach((slide) => {
                    slide.slide(this.lastOffset);
                });
                setTimeout(() => {
                    let /** @type {?} */ ref = this.viewContainerRef.get(this.carouselSlides.length - 1);
                    this.viewContainerRef.move(ref, 0);
                    this.lastOffset -= this.sliderContainer.nativeElement.getBoundingClientRect().width;
                    this.carouselSlides.forEach((slide) => {
                        slide.stabilizes(this.lastOffset);
                    });
                    this.state = STATE_AVAILABLE;
                    this.index--;
                    if (this.index < 0) {
                        this.index = this.slides.length - 1;
                    }
                }, 720);
                setTimeout(() => {
                    this.pause = false;
                }, this.time * 1000);
            }
        }


        // if (index > this.index) {
        //     this.slideForward();
        // } else if (index < this.index) {
        //     this.slideBack();
        // }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'pac-slider',
    template: `
      <div class="carousel-container" #sliderContainer>

          <!-- Left Arrow Container -->
          <div class="arrow left-arrow"
               (click)="slideBack()"
               (mouseenter)="pauseAutoPlay()">
              <div class="arrow-wrapper">
                  <div id="left-arrow"></div>
              </div>
          </div>

          <!-- Slider Zone -->
          <div class="slides-zone" #slidesZone>
              <ng-content></ng-content>
              <div class="images-container"
                   (mouseenter)="pauseAutoPlay()"
                   (mouseleave)="startAutoPlay()"
                   (panstart)="onPanStart($event)"
                   (panmove)="onPan($event)"
                   (panend)="onPanEnd()"
                   #slideImg>
                  <ng-template slideZone>

                  </ng-template>
              </div>
          </div>

          <!-- Dots Container -->
          <div class="dots-container">
              <ul (mouseenter)="pauseAutoPlay()"
                  (mouseleave)="startAutoPlay()">
                  <li *ngFor="let dot of slides;let i = index;"
                      (click)="slideToIndex(i)"
                      [ngClass]="{selected: i == index}">
                  </li>
              </ul>
          </div>

          <!-- Right Arrow Container -->
          <div class="arrow right-arrow"
               (click)="slideForward()"
               (mouseenter)="pauseAutoPlay()">
              <div class="arrow-wrapper">
                  <div id="right-arrow"></div>
              </div>
          </div>

      </div>
    `,
    styles: [`
      .carousel-container {
        width: 100%;
        max-height: 100vh;
        overflow: hidden;
        position: relative; }
        .carousel-container .images-container {
          width: 100%;
          display: -ms-flexbox;
          display: -webkit-box;
          display: flex;
          -ms-flex: 1;
          -webkit-box-flex: 1;
                  flex: 1;
          -ms-flex-align: center;
          -webkit-box-align: center;
                  align-items: center;
          -ms-flex-pack: start;
          -webkit-box-pack: start;
                  justify-content: flex-start;
          -webkit-transition: all 300ms cubic-bezier(0.35, 0, 0.25, 1);
          transition: all 300ms cubic-bezier(0.35, 0, 0.25, 1); }
        .carousel-container .arrow {
          z-index: 2;
          position: absolute;
          top: 0;
          height: 100%;
          width: 6%;
          min-width: 60px;
          display: -ms-flexbox;
          display: -webkit-box;
          display: flex;
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
          -ms-flex-wrap: nowrap;
          flex-wrap: nowrap;
          -ms-flex-pack: center;
          -webkit-box-pack: center;
                  justify-content: center;
          -ms-flex-line-pack: stretch;
          align-content: stretch;
          -ms-flex-align: center;
          -webkit-box-align: center;
                  align-items: center; }
          .carousel-container .arrow .arrow-wrapper {
            position: relative;
            width: 20px;
            height: 20px;
            -ms-flex-order: 0;
            -webkit-box-ordinal-group: 1;
                    order: 0;
            -ms-flex: 0 1 auto;
            -webkit-box-flex: 0;
                    flex: 0 1 auto;
            -webkit-align-self: auto;
            -ms-flex-item-align: auto;
            align-self: auto; }
            .carousel-container .arrow .arrow-wrapper #right-arrow {
              position: absolute;
              height: 20px;
              width: 20px;
              /* IE 9 */
              -webkit-transform: rotate(45deg);
              /* Chrome, Safari, Opera */
              transform: rotate(45deg);
              border-right: 2px solid #ffffff;
              border-top: 2px solid #ffffff; }
            .carousel-container .arrow .arrow-wrapper #left-arrow {
              position: absolute;
              height: 20px;
              width: 20px;
              /* IE 9 */
              -webkit-transform: rotate(45deg);
              /* Chrome, Safari, Opera */
              transform: rotate(45deg);
              border-left: 2px solid #ffffff;
              border-bottom: 2px solid #ffffff; }
          .carousel-container .arrow.left-arrow {
            left: 0;
            cursor: pointer; }
          .carousel-container .arrow.right-arrow {
            right: 0;
            cursor: pointer; }
        .carousel-container .dots-container {
          z-index: 2;
          position: absolute;
          bottom: 0;
          height: 10%;
          width: 100%;
          display: -ms-flexbox;
          display: -webkit-box;
          display: flex;
          -ms-flex-direction: row;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
                  flex-direction: row;
          -ms-flex-wrap: nowrap;
          flex-wrap: nowrap;
          -ms-flex-pack: center;
          -webkit-box-pack: center;
                  justify-content: center;
          -ms-flex-line-pack: stretch;
          align-content: stretch;
          -ms-flex-align: center;
          -webkit-box-align: center;
                  align-items: center; }
          .carousel-container .dots-container ul {
            list-style-type: none;
            margin: 0;
            padding: 0;
            overflow: hidden; }
            .carousel-container .dots-container ul li {
              cursor: pointer;
              height: 10px;
              width: 10px;
              background: #fff;
              border-radius: 100%;
              margin: 5px;
              display: inline-table;
              opacity: .5; }
              .carousel-container .dots-container ul li.selected {
                opacity: 1; }
    `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ComponentFactoryResolver, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'autoPlay': [{ type: Input },],
'time': [{ type: Input },],
'slidesZone': [{ type: ViewChild, args: ['slidesZone', ] },],
'sliderContainer': [{ type: ViewChild, args: ['sliderContainer', ] },],
'slideZone': [{ type: ViewChild, args: [SlideZoneDirective, ] },],
'onResize': [{ type: HostListener, args: ['window:resize', ['$event'], ] },],
};
}

function CarouselComponent_tsickle_Closure_declarations() {
/** @type {?} */
CarouselComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CarouselComponent.ctorParameters;
/** @type {?} */
CarouselComponent.propDecorators;
/** @type {?} */
CarouselComponent.prototype.autoPlay;
/** @type {?} */
CarouselComponent.prototype.time;
/** @type {?} */
CarouselComponent.prototype.slidesZone;
/** @type {?} */
CarouselComponent.prototype.sliderContainer;
/** @type {?} */
CarouselComponent.prototype.slideZone;
/** @type {?} */
CarouselComponent.prototype.slides;
/** @type {?} */
CarouselComponent.prototype.viewContainerRef;
/** @type {?} */
CarouselComponent.prototype.carouselSlides;
/** @type {?} */
CarouselComponent.prototype.x;
/** @type {?} */
CarouselComponent.prototype.startX;
/** @type {?} */
CarouselComponent.prototype.state;
/** @type {?} */
CarouselComponent.prototype.lastOffset;
/** @type {?} */
CarouselComponent.prototype.index;
/** @type {?} */
CarouselComponent.prototype.interval;
/** @type {?} */
CarouselComponent.prototype.pause;
/** @type {?} */
CarouselComponent.prototype.initialWindowWidth;
/** @type {?} */
CarouselComponent.prototype.componentFactoryResolver;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
